import type { CategoryData } from "@/utils/server/mdx";
import { SearchDocuments, type SearchTarget } from "@/components/SearchDocuments/SearchDocuments";
import { DocsItems } from "./DocsItems/DocsItems";
import { Spacer } from "@/aviaryTmp/Spacer/Spacer";
import * as styles from "./DocsLeftContent.styles";

const SEARCH_TARGETS: SearchTarget[] = ["Getting started", "How-to guides"];

const DocsLeftContent = ({ categories }: { categories: CategoryData }) => {
  return (
    <div css={styles.container}>
      <SearchDocuments searchTargets={SEARCH_TARGETS} />
      <Spacer height="one" />
      <DocsItems categories={categories} />
    </div>
  );
};

export { DocsLeftContent };
